/**
 * Token Mapbox para checkout delivery.
 * CRA inyecta REACT_APP_MAPBOX_TOKEN en build time (Netlify: variable de entorno del sitio).
 *
 * El JS/CSS de Mapbox se carga bajo demanda (modal de domicilio), no al abrir la carta.
 */

const MAPBOX_VERSION = "v3.5.1";
const MAPBOX_CSS = `https://api.mapbox.com/mapbox-gl-js/${MAPBOX_VERSION}/mapbox-gl.css`;
const MAPBOX_JS = `https://api.mapbox.com/mapbox-gl-js/${MAPBOX_VERSION}/mapbox-gl.js`;

let mapboxLoadPromise = null;

/**
 * @returns {string|null}
 */
export function getMapboxToken() {
  const token = process.env.REACT_APP_MAPBOX_TOKEN;
  if (typeof token !== "string") {
    return null;
  }
  const trimmed = token.trim();
  return trimmed || null;
}

/**
 * @returns {boolean}
 */
export function mapboxDisponible() {
  return Boolean(
    getMapboxToken() &&
      typeof window !== "undefined" &&
      window.mapboxgl
  );
}

/**
 * Inyecta Mapbox GL una sola vez. No hace nada si ya está en window.
 *
 * @returns {Promise<boolean>}
 */
export function ensureMapbox() {
  if (typeof window === "undefined") {
    return Promise.resolve(false);
  }
  if (window.mapboxgl) {
    return Promise.resolve(true);
  }
  if (mapboxLoadPromise) {
    return mapboxLoadPromise;
  }

  mapboxLoadPromise = new Promise((resolve) => {
    if (!document.querySelector(`link[href="${MAPBOX_CSS}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = MAPBOX_CSS;
      document.head.appendChild(link);
    }

    const onDone = (ok) => {
      if (!ok) {
        mapboxLoadPromise = null;
      }
      resolve(ok);
    };

    const existente = document.querySelector(`script[src="${MAPBOX_JS}"]`);
    if (existente) {
      existente.addEventListener("load", () => onDone(Boolean(window.mapboxgl)));
      existente.addEventListener("error", () => onDone(false));
      return;
    }

    const script = document.createElement("script");
    script.src = MAPBOX_JS;
    script.async = true;
    script.onload = () => onDone(Boolean(window.mapboxgl));
    script.onerror = () => onDone(false);
    document.head.appendChild(script);
  });

  return mapboxLoadPromise;
}
